export const color = {
  available: "#fff",
  used: "#0fb9b1",
  wrong: "#3867d6",
  candidate: "#a55eea",
};
